// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","819":"bdaa20e367ed17d13e6b"}[chunkId] + ".js";
};